import { Pipe, PipeTransform } from '@angular/core';
import { SortHelper } from '../sort-helper.util';

@Pipe({
  name: 'sorterClasses',
  standalone: true,
})
export class SorterClassesPipe implements PipeTransform {
  public transform(sorter: SortHelper, ...args: any[]): Record<string, boolean> {
    const [attr, location] = args;
    return sorter.getSorterClasses(location, attr);
  }
}
